(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-cart-recovery"] && !Shopify.designMode) return;
  try {
    (function () {
'use strict';

// Read-only snapshot builder. Never changes merchandise, discounts or tags.
function buildSnapshot(cart, origin = 'https://www.scummybears.com') {
  if (!cart || !Array.isArray(cart.items)) throw new TypeError('Missing cart items');
  const result = {
    SchemaVersion: 1,
    ItemCount: 0,
    Currency: cart.currency,
    CartTotal: Number(cart.total_price) / 100,
    Items: [],
    RecoveryURL: '',
    Recoverable: false,
    Reason: ''
  };
  const unsupported = [];
  const seen = new Set();
  const url = new URL('/cart/', origin);
  for (const line of cart.items) {
    const id = String(line.variant_id || line.id);
    if (!/^\d+$/.test(id) || !Number.isSafeInteger(line.quantity) || line.quantity <= 0) {
      throw new TypeError('Invalid variant or quantity');
    }
    if (seen.has(id)) unsupported.push('distinct_lines_for_same_variant');
    seen.add(id);
    if (line.selling_plan_allocation) unsupported.push('selling_plan');
    if (line.parent_relationship || line.item_components?.length) unsupported.push('nested_bundle');
    if (Object.keys(line.properties || {}).length) unsupported.push('line_item_properties');
    if (line.recovery_metadata?.purchasable === false) unsupported.push('unavailable_product');
    result.ItemCount += line.quantity;
    result.Items.push({
      VariantID: id,
      ProductID: String(line.product_id),
      ProductName: line.product_title || line.title || '',
      VariantName: line.variant_title === 'Default Title' ? '' : (line.variant_title || ''),
      Quantity: line.quantity,
      Price: Number(line.final_price ?? line.price) / 100,
      LinePrice: Number(line.final_line_price ?? line.line_price) / 100,
      ImageURL: line.featured_image?.url || line.image || '',
      URL: new URL(line.url, origin).href,
      Preorder: line.recovery_metadata?.preorder === true,
      ShipMessage: line.recovery_metadata?.ship_message || ''
    });
  }
  if (!result.Items.length) unsupported.push('empty_cart');
  if (Object.keys(cart.attributes || {}).length) unsupported.push('cart_attributes');
  if (cart.note) unsupported.push('cart_note');
  if (!/^[A-Z]{3}$/.test(result.Currency || '') || !Number.isFinite(result.CartTotal)) {
    throw new TypeError('Invalid currency or total');
  }
  if (unsupported.length) {
    result.Reason = [...new Set(unsupported)].join(',');
    return result;
  }
  url.pathname += result.Items.map(line => `${line.VariantID}:${line.Quantity}`).join(',');
  url.searchParams.set('storefront', 'true');
  const codes = (cart.discount_codes || []).filter(d => d.applicable).map(d => d.code);
  if (codes.length) url.searchParams.set('discount', codes.join(','));
  result.RecoveryURL = url.href;
  result.Recoverable = true;
  return result;
}

if (typeof module !== 'undefined') module.exports = { buildSnapshot };

'use strict';

// Dependency injection keeps the actual cart/SDK behavior testable without
// sending real events. This observer never changes the cart or its item data.
function createCapture({buildSnapshot, readCart, isAllowed, isIdentified, track, environment, uuid,
  loadSignature = () => '', saveSignature = () => {}, fingerprint = async value => value,
  onError = () => {}}) {
  let last = '';
  let running = false;
  let pending = false;
  let version = 0;
  return async function capture() {
    version += 1;
    if (running) { pending = true; return; }
    running = true;
    try {
      do {
        pending = false;
        const requestVersion = version;
        if (!isAllowed() || !await isIdentified()) continue;
        const cart = await readCart();
        if (requestVersion !== version) { pending = true; continue; }
        const snapshot = buildSnapshot(cart);
        const signature = await fingerprint(JSON.stringify(snapshot));
        const saved = loadSignature();
        if (signature === last || signature === saved) continue;
        if (!isAllowed()) continue;
        const accepted = await track('SB Cart Updated', {
          ...snapshot,
          Environment: environment,
          TestEvent: environment !== 'live',
          $event_id: uuid()
        });
        // Failed requests remain eligible for a later natural retry.
        if (accepted) {
          last = signature;
          saveSignature(signature);
        }
      } while (pending);
    } catch (error) {
      onError(error);
    } finally { running = false; }
  };
}

if (typeof module !== 'undefined') module.exports = {createCapture};

(function () {
  'use strict';
  // Preview candidate only. Publishing this theme must not enable unverified tracking.
  if (!window.Shopify || !window.Shopify.theme || window.Shopify.theme.role === 'main') return;
  if (window.sbCartRecoveryObserver) return;
  window.sbCartRecoveryObserver = true;
  const environment = 'preview';
  const storageKey = 'sb-cart-recovery-v1-' + environment;
  let timer;
  let attempts = 0;
  const allowed = () => {
    const p = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(p && p.analyticsProcessingAllowed() && p.marketingAllowed());
  };
  const bounded = (promise, milliseconds) => {
    let timeout;
    return Promise.race([promise, new Promise((_, reject) => {
      timeout = setTimeout(() => reject(new Error('Cart recovery request timed out')), milliseconds);
    })]).finally(() => clearTimeout(timeout));
  };
  const sdk = () => window.klaviyo;
  const capture = createCapture({
    buildSnapshot,
    environment,
    uuid: () => crypto.randomUUID(),
    isAllowed: allowed,
    isIdentified: async () => {
      const k = sdk();
      if (!k || typeof k.isIdentified !== 'function') return false;
      return bounded(k.isIdentified(), 6000);
    },
    readCart: async () => {
      const root = window.Shopify.routes.root;
      const url = new URL(root + 'cart', location.origin);
      url.searchParams.set('sections', 'sb-cart-recovery-data');
      const options = () => ({credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000)});
      const [response, cartResponse] = await Promise.all([
        fetch(url, options()), fetch(new URL(root + 'cart.js', location.origin), options())
      ]);
      if (!response.ok || !cartResponse.ok) throw new Error('Cart recovery data unavailable');
      const sections = await response.json();
      const markup = sections['sb-cart-recovery-data'];
      if (!markup) throw new Error('Cart recovery section missing');
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const node = doc.querySelector('[data-sb-cart-recovery-data]');
      if (!node) throw new Error('Cart recovery data missing');
      const data = JSON.parse(node.textContent);
      const cart = await cartResponse.json();
      const lines = value => value.items.map(i => [String(i.variant_id || i.id),i.quantity]).sort().map(i=>i.join(':')).join(',');
      if (lines(cart) !== lines(data.cart)) throw new Error('Cart changed while reading product metadata');
      for (const line of cart.items) {
        const metadata = data.metadata.find(m => String(m.variant_id) === String(line.variant_id || line.id));
        if (!metadata) throw new Error('Cart recovery product metadata missing');
        line.recovery_metadata = metadata;
      }
      return cart;
    },
    track: async (name, event) => {
      const accepted = await bounded(sdk().track(name, event), 8000);
      if (accepted) attempts = 0;
      return accepted;
    },
    fingerprint: async value => {
      const bytes = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
      return Array.from(new Uint8Array(bytes), b => b.toString(16).padStart(2, '0')).join('');
    },
    loadSignature: () => {
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey));
        return saved && Date.now() - saved.time < 3 * 86400000 ? saved.signature : '';
      } catch (_) { return ''; }
    },
    saveSignature: signature => {
      try { localStorage.setItem(storageKey, JSON.stringify({signature, time: Date.now()})); } catch (_) {}
    },
    onError: () => {
      if (attempts < 2) { attempts++; clearTimeout(timer); timer = setTimeout(capture, attempts * 5000); }
    }
  });
  const schedule = () => { clearTimeout(timer); timer = setTimeout(capture, 400); };
  ['rebuy:cart.ready', 'rebuy:cart.change', 'cart:updated', 'visitorConsentCollected'].forEach(name => {
    document.addEventListener(name, schedule);
  });
  window.addEventListener('klaviyoForms', event => {
    if (event.detail && event.detail.type === 'submit') schedule();
  });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('online', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  schedule();
  setTimeout(schedule, 5000);
  setTimeout(schedule, 15000);
}());

}());
  } catch(e) { console.error(e); }
})();

})();
